import RfiRequestsTable from './RfiRequestsTable.component';

export default RfiRequestsTable;
